<template>
  <div>
    <page-header
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
      class="mt-3 mt-md-0"
      @onReturn="() => $router.back()"
      :has-return="true"
    />
    <filter-manager
      :display-advanced="false"
      class="search-bar"
      search-icon="fa fa-sync"
      search-text="Procesar"
      search-container-class="btn-process"
      v-model="model.search.filters"
      :filters="filterManagerConfig"
      @search="onHandlerSearch"
      ref="filterRef"
    />
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@/modules/report/document'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'

export default {
  name: 'ParentInventoryMain',
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    model: {
      search: {
        collections: {
          academicYears: [],
        },
        filters: {
          academicYear: null,
        },
      },
    },
  }),
  computed: {
    headerConfig() {
      return {
        title: 'Inventario de Padres',
        icon:
          'fa-solid fa-magnifying-glass-chart pr-0 font-22 magnifying-glass-icon-m ',
        routes: ['Inicio', 'Informes Generales', 'Estudiantes', 'Inventario de Padres'],
      }
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'description',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'El año académico es requerido.',
          validations: 'required',
          clearable: false,
          class: 'col-12 col-md-3',
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
        },
      ]
    },
  },
  async mounted() {
    await this.setFilters();
  },
  methods: {
    hasValue(param) {
      return param !== null && param !== undefined
    },
    async setFilters() {
      const { data: years } = await AcademicYearServices.getAcademicYearsWithParentInventory();
      this.model.search.collections.academicYears = [...years];
      if (years.length > 0) {
        this.model.search.filters.academicYear = years[0];
      }
    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()
      if (isValid) {
        await this.process()
      }
    },
    async process() {
      if (this.hasValue(this.model.search.filters.academicYear?.id)) {
        await ReportServices.getReport('parentinventory', {
          academicYearId: this.model.search.filters.academicYear.id,
        }).then((res) => DocumentServices.Download(res.data))
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>

